// extracted by mini-css-extract-plugin
export default {"name":"PostInfo_name__XkscN","createdAt":"PostInfo_createdAt__2ao6F"};